import { NoteRepository } from '../data/db'

/**
 * When the welcome shows (docs/onboarding/ONBOARDING_PROPOSAL.md, "When the welcome shows"): only for a scope that has never held a note
 * and has not seen it, once the inventory is ready and no account restore is running. A note in any status ends it for good, so deleting every note later gives the quiet empty state, not the tour.
 */
export interface WelcomeState { inventoryReady: boolean; noteCount: number; seen: boolean; restoring: boolean }

export function shouldShowWelcome(state: WelcomeState): boolean {
  return state.inventoryReady && !state.restoring && state.noteCount === 0 && !state.seen
}

/**
 * The flag is a local row in the workspace database's `meta` store, keyed by the account scope (a guest's is `local-review`): the synced
 * settings are a server-validated record, and one flag for one device does not warrant a schema change (tracker Q-01).
 */
export const welcomeKey = (scope: string) => `welcome:v1:${scope}`

export async function readWelcomeSeen(scope: string, repository = new NoteRepository()): Promise<boolean> {
  return (await repository.getMeta(welcomeKey(scope))) === true
}

export async function writeWelcomeSeen(scope: string, repository = new NoteRepository()): Promise<void> {
  await repository.setMeta(welcomeKey(scope), true)
}
